import { useContext } from "react";

import { useMuxSpecificationApi } from "../../../../../common/api/orders-api/mux-specification/useMuxSpecificationApi";
import { Language, getLanguageDisplayName } from "../../../../../common/types/Language";
import { MuxSpecificationDashboardContext } from "../../context/MuxSpecificationDashboardContext";
import { EditLanguageSpecificationFormInputs } from "./EditLanguageSpecificationMappingForm";

export const useEditLanguagexSpecificationMappingForm = () => {
    const { updateManzanitaLanguageSpecificationMapping } = useMuxSpecificationApi();
    const {
        muxSpecificationDashboardItem,
        updateManzanitaLanguageSpecificationMapping: updateMappingInContext
    } = useContext(MuxSpecificationDashboardContext);

    const editLanguageSpecificationMapping = async (
        language: Language,
        inputs: EditLanguageSpecificationFormInputs
    ) => {
        const soundtrackPid = inputs.soundtrackPid;
        const subtitlePid = inputs.subtitlePid;

        await updateManzanitaLanguageSpecificationMapping({
            muxSpecificationId: muxSpecificationDashboardItem.id,
            languageId: language.id,
            soundtrackPid,
            subtitlePid
        });

        updateMappingInContext({
            id: language.id,
            languageDisplayName: getLanguageDisplayName(language),
            soundtrackPid,
            subtitlePid
        });
    };

    return {
        editLanguageSpecificationMapping
    };
};
